module.exports = __webpack_public_path__ + "static/img/返回顶部.c8b3066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/返回顶部.png
// module id = ZzlK
// module chunks = 16